import { render, staticRenderFns } from "./Clrmg.vue?vue&type=template&id=33bacf8e&scoped=true&"
import script from "./Clrmg.vue?vue&type=script&lang=js&"
export * from "./Clrmg.vue?vue&type=script&lang=js&"
import style0 from "./Clrmg.vue?vue&type=style&index=0&id=33bacf8e&lang=less&scoped=true&"
import style1 from "./Clrmg.vue?vue&type=style&index=1&id=33bacf8e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bacf8e",
  null
  
)

export default component.exports